export enum HealthStatusStatus {
    Pass = 'pass',
    Fail = 'fail',
}